import { ChevronRightIcon } from '@/common/assets';
import RoundButton from '../RoundButton/RoundButton';
import type { MatchGroupPreviousProps } from './Knockout.types';

export function MatchGroupPrevious(props: MatchGroupPreviousProps) {
  const { onButtonClick } = props;

  return (
    <div className="z-0 relative flex-1 flex items-center justify-center">
      <RoundButton
        aria-label="Previous round"
        icon={
          <ChevronRightIcon
            aria-hidden="true"
            className="rotate-180 text-pmw-icon-fill-secondary-light dark:text-pmw-icon-fill-secondary-dark"
          />
        }
        onClick={onButtonClick}
      />
      <div className="z-[-1] absolute w-full h-px bg-pmw-fc-brand-light dark:bg-pmw-fc-brand-dark" />
    </div>
  );
}
